import { type ProjectCode } from '@constants'
import { useApiCampaignProductsToB } from '@hooks-api/fortune/useApiCampaignProductsToB'
import { useMemo } from 'react'
import { fpConvertB2bProductCatalogDTO } from '../../dtos/fpConvertProductCatalogDTO'
import { cartStoreMap, type PlatformType } from './store-map'

export const useFpB2bProductCatalogProducts = (campaignId: number, projectCode: ProjectCode, campaignCode: string | undefined, platform: PlatformType) => {
  const { useCartStore } = cartStoreMap[platform]
  const [cartValues] = useCartStore(campaignId)
  const response = useApiCampaignProductsToB({
    code: campaignCode,
    project_code: projectCode,
    merchant_id: cartValues.merchant.index,
    manual_input_coupon_ids: cartValues.coupon.manualInputCouponIds.join(','),
  }, {
    keepPreviousData: true,
  })
  const productCatalogDto = useMemo(
    () => !response.error && response.data?.data ? fpConvertB2bProductCatalogDTO(response.data.data) : undefined,
    [response.data, response.error],
  )
  return {
    ...response,
    productCatalogDto,
  }
}
